import { useMegaBroker } from './broker';
class ClientChannelMobile {
    constructor(token) {
        this.closed = false;
        this.subscribe = (eventName, handler) => {
            if (this.isClosed()) {
                throw new Error('channel is closed');
            }
            return useMegaBroker().transport.subscribe(this.token, eventName, handler);
        };
        this.publish = (eventName, ...args) => {
            if (this.isClosed()) {
                throw new Error('channel is closed');
            }
            useMegaBroker().transport.publish({
                token: this.token,
                eventName: eventName,
                args,
            });
        };
        // 移动端无需实现
        this.fire = () => { };
        this.close = () => {
            this.unsubscribe();
            this.closed = true;
        };
        this.isClosed = () => {
            return this.closed;
        };
        this.unsubscribe = () => {
            useMegaBroker().transport.unsubscribe(this.token);
        };
        this.token = token;
    }
}
export default ClientChannelMobile;
//# sourceMappingURL=client-channel-mobile.js.map